export const DEFAULT_ANY_OPTION = 'Any'

export default {}
